import React, { useState, useEffect } from "react";
import PaginatorContainer from "items/paginator/paginator-container";
import TableItem from "items/table/table";
import DropdownController from "items/dropdown/dropdown-controller";
import SearchBlock from "../search-block/search-block";
import s from "./admin-markers.module.scss"

const AdminMarkers = (props) => {

    const setSelectedSort = (sort, type) => {
        if(sort === 'STATUS'){
            sortByStatus(type);
        }
        else{
            sortByOrder(sort, type)
            //props.setSort(sort);
        }
        
    }

    const sortByStatus = (status) => {
        props.setSortByStatus(status)
        setStatus(status);
    }

    const sortByOrder = (sort, type) => {
        setSort(sort, type);
        //props.setSortDirection(type)
        let items = type.split(" ");
        props.setSort(items[0], items[1]);

        //setSortBy(items[0]);
        //setRerender(!rerender);
        //setSortByDirection(items[1])
    }

    const getSort = (sort) => {
        switch(sort){
            case 'ALPHABETIC':
                return alphabetic
            case 'CREATED_AT':
                return created
            case 'UPDATED_AT':
                return updated
            case 'STATUS':
                return status
        }
        
    }

    const setSort = (type, sort) => {
        switch(type){
            case 'ALPHABETIC':
                setAlphabetic(sort);
                setCreated('CREATED_AT DESC');
                break;
            case 'CREATED_AT':
                setCreated(sort);
                setUpdated('UPDATED_AT DESC');
                setAlphabetic('ALPHABETIC DESC')
                break;
            case 'UPDATED_AT':
                setUpdated(sort);
                setCreated('CREATED_AT DESC');
                setAlphabetic('ALPHABETIC DESC')
                break;
            case 'STATUS':
                setStatus();
                break;
        }
    }

    const getHeaderComponents = (headers, selected) => {
        let retHeaders = props.tableHeader && props.tableHeader.map((item, i) => {
            let t = item
            if(item.name === 'dropdown'){
                let titles = item.items.map((title)=>{return {title: props.getValue(title.title), short_name: title.short_name, name: title.name}});
                return <DropdownController
                            items={titles}
                            name={item.name}
                            callback={setSelectedSort}
                            selected={getSort(item.title)}
                            icon={null}
                            type={item.title}
                            short_name={'short_names'}
                        /> 
            }
            else{
                return props.getValue(item)
            }
        })
        return retHeaders
    }

    const getSelectedSort = (sort) => {
        let sorting = props.tableHeader.findIndex((f, i) => {return f.title === sort})
        let ret = sorting !== -1 ? props.tableHeader[sorting].items[0].short_name : sort
        return ret;
    }
    
    const [alphabetic, setAlphabetic] = useState(getSelectedSort('ALPHABETIC'));
    const [selectedItem, setSelectedItem] = useState(props.selectedItem);
    const [created, setCreated] = useState(getSelectedSort('CREATED_AT'));
    const [updated, setUpdated] = useState(getSelectedSort('UPDATED_AT'));
    const [searchText, setSearchText] = useState(props.searchText);
    const [searchStart, setSearchStart] = useState(false);
    const [status, setStatus] = useState(props.status);
    let [tableHeaders, setTableHeaders] = useState(getHeaderComponents(props.tableHeader));

    useEffect(()=>{
        setSelectedItem(props.selectedItem)
        setTableHeaders(getHeaderComponents(props.tableHeader));
        setSearchText(props.searchText)
        setStatus(props.status);
    }, [props])

    const selectTableITem = (item) => {
        if(selectedItem !== item){
            props.setSelectedItem(item, props.data[item]);
        }
    }

    const searchItem = (search) => {
        if(search){
            props.search(search);
            setSearchStart(true)
        }
        else{
            setSearchText('')
            props.search('')
            setSearchStart(false)
            setRerender(!rerender)
        }
    }

    return <div className={s.AdminMarkers}>
        <PaginatorContainer />

        <SearchBlock getValue={props.getValue} searchItem={searchItem} searchText={searchText}/>

        { <TableItem 
                                    data={[tableHeaders, props.data]} 
                                    getValue={props.getValue} 
                                    //titleText={props.getValue('LIST_OF_USERS')}
                                    hiddenColumns={props.hiddenColumns}
                                    topics={props.topics}
                                    selectItem={selectTableITem}
                                    selectedItem={selectedItem}
                                    //controllerButtons={props.controllerButtons}
                                    //controlButtons={props.controlButtons}
                                    //tableColWidth={{index: 6, width: 82}}
                                    height={415}
                                    weekDays={props.weekDays}
                                    hidden={props.deviceType === 'mobile' ? [3,4] : []}
                                    hiddenInEdit={[4]}
                                    />}
    </div>
}

export default AdminMarkers;